import { MouseEventHandler, ReactNode } from 'react';

import { TestAttributeProps } from 'types/testAttribute/';

import { CssClass } from '../styled';

export type ButtonMode =
  | 'standard'
  | 'standard-small'
  | 'medium'
  | 'small'
  | 'outlined'
  | 'text'
  | 'outlined-small';
export type ButtonColorVariant = 'primary' | 'red';

export interface ButtonProps extends TestAttributeProps {
  /** The text displayed on the button */
  label?: string;
  /** The visual style of the button. */
  mode?: ButtonMode;
  /** The color. */
  colorVariant?: ButtonColorVariant;
  /** Disabled button. */
  disabled?: boolean;
  /** Loading button. */
  loading?: boolean;
  /** Element placed before the children. */
  startIcon?: ReactNode;
  /** Class name. */
  className?: string;
  /** Full width. */
  fullWidth?: boolean;

  href?: string;
  /** The click event handler for the button */
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const ButtonClasses = {
  icon: new CssClass('button-icon'),
  label: new CssClass('button-label'),
  loading: new CssClass('button-loading'),
} as const;
